import { useState } from 'react';

import { LookupAutocompleteView } from '@/shared/ui/molecules/LookupAutocomplete';

import { useCouponSearchDropdown } from '../../../hooks/useCouponSearchDropdown';

import type { LookupAutocompleteProps } from './StudentAutocomplete';

/** Autocomplete de cupom (lookup `individualpayment/editors/coupons`). */
export function CouponAutocomplete({
  value,
  selectedLabel,
  onChange,
  label,
  placeholder,
}: LookupAutocompleteProps) {
  const [search, setSearch] = useState('');
  const { options, isQuerySuccess } = useCouponSearchDropdown(search);

  return (
    <LookupAutocompleteView
      label={label}
      placeholder={placeholder}
      value={value}
      selectedLabel={selectedLabel}
      options={options}
      isQuerySuccess={isQuerySuccess}
      search={search}
      onSearchChange={setSearch}
      onSelect={(id, itemLabel) => {
        onChange(id, itemLabel);
        setSearch('');
      }}
      onClear={() => {
        onChange('', '');
        setSearch('');
      }}
    />
  );
}
